import React, {useState} from 'react'
import {MDBBtn, MDBContainer} from 'mdb-react-ui-kit'
import FadeIn from 'react-fade-in'
import LevelOne from './Leveles/LevelOne'
import {HandlePageWelcome} from '../../../../context/HandlePageWelcome'
import LevelTwo from './Leveles/LevelTwo'
import LevelThree from './Leveles/LevelThree'

const WelcomeToRegister = () => {
  const [page, setPage] = useState(1)
  const valueCTX: HandlePageWelcome =  {
    page: page,
    setPage: setPage
  }
  return (
    <div className={'bg-kian w-100 h-full overflow-hidden'}>
        <HandlePageWelcome.Provider value={valueCTX}>
          <MDBContainer className={'h-100'}>
            {page}
            {(() => {
              switch(page) {
                case 1:
                  return (
                    <FadeIn className={'h-50'}>
                      <LevelOne />
                    </FadeIn>
                  )
                case 2:
                  return (
                    <FadeIn className={'h-full'}  >
                      <LevelTwo />
                    </FadeIn>
                  )
                case 3:
                  return (
                    <FadeIn className={'h-full'}  >
                      <LevelThree />
                    </FadeIn>
                  )

              }
            })()}
          </MDBContainer>
        </HandlePageWelcome.Provider>
    </div>
  )
}
export default WelcomeToRegister


